module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-mid"
  }, [_c('div', {
    staticClass: "swipe-wrap"
  }, [_c('list-ad', {
    attrs: {
      "data": _vm.middleUpAdv.advList
    }
  }), _vm._v(" "), _c('list-ad', {
    attrs: {
      "data": _vm.middleDownAdv.advList
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71b52d98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/home-module/middle-ad/index.vue
// module id = 1635
// module chunks = 1